<div (mouseleave)="closePopup()" (mousemove)="$event.stopPropagation()">
  <resource-panel [model]="model" [searchId]="searchId"></resource-panel>
</div>
